import React from 'react';

import { cidadeNormal09 } from '../components/HeroBusiness/Data';

import HeaderMenu from '../components/HeaderMenu';
import HeroBusiness from '../components/HeroBusiness';
import Footer from '../components/Footer';


const CidadeNormal09 = () => {
  return (
    <>
    <HeaderMenu />
    <HeroBusiness {...cidadeNormal09}/>
    <Footer />
      
    </>
  )
}

export default CidadeNormal09
